<template>
  <el-drawer
    :visible.sync="visible"
    :title="headTitle"
    direction="rtl"
    size="50%"
    :before-close="handleClose"
    :destroy-on-close="true"
  >
    <Main
      v-if="visible"
      :content-title="contentTitle"
      :issue-type="issueType"
      @confirm="handleConfirm"
      @close="close"
    />
  </el-drawer>
</template>

<script>
import Main from './main.vue'

export default {
  name: 'DefectIssuesDrawer',
  components: { Main },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    headTitle: {
      type: String,
      default: ''
    },
    contentTitle: {
      type: String,
      default: ''
    },
    issueType: {
      type: String,
      default: ''
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    close() {
      this.visible = false
      this.$emit('close')
    },
    handleClose() {
      this.$confirm('关闭后填写的数据将会丢失，确认关闭吗？', '操作提示', {
        confirmButtonText: '关闭',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.visible = false
          this.$emit('close')
        })
        .catch(() => {})
    },
    handleConfirm(data) {
      this.$emit('confirm', data)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-drawer) {
  .el-drawer__header {
    padding: 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #e8e8e8;
    > span {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .el-drawer__body {
    padding: 20px;
    overflow-y: auto;
  }
}
</style>
